import { NavLink, Navigate, Route, Routes } from 'react-router-dom';

import { useAuth } from './auth/AuthProvider';
import { Company } from './routes/Company';
import { Conversations, ConversationView } from './routes/Conversations';
import { CustomerDetail } from './routes/CustomerDetail';
import { Customers } from './routes/Customers';
import { Dashboard } from './routes/Dashboard';
import { Health } from './routes/Health';
import { Login } from './routes/Login';
import { Trends } from './routes/Trends';
import { Users } from './routes/Users';

export function App() {
  const { user } = useAuth();

  // One gate, at the top. Every route below it is only reachable by somebody the API has already
  // told us is an operator — and the API checks again on every request regardless.
  if (!user) return <Login />;

  return (
    <div className="shell">
      <Sidebar />
      <main className="main">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/customers/:organisationId" element={<CustomerDetail />} />
          <Route path="/conversations" element={<Conversations />} />
          <Route path="/conversations/:conversationId" element={<ConversationView />} />
          <Route path="/health" element={<Health />} />
          <Route path="/trends" element={<Trends />} />
          <Route path="/users" element={<Users />} />
          <Route path="/company" element={<Company />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

const NAV: { group: string; links: { to: string; label: string; end?: boolean }[] }[] = [
  {
    group: 'Business',
    links: [
      { to: '/', label: 'Command centre', end: true },
      { to: '/customers', label: 'Customers' },
      { to: '/users', label: 'Users' },
    ],
  },
  {
    group: 'Product',
    links: [
      { to: '/conversations', label: 'Conversations' },
      { to: '/health', label: 'Health' },
      { to: '/trends', label: 'Trends' },
    ],
  },
  {
    group: 'Company',
    links: [{ to: '/company', label: 'Operations' }],
  },
];

function Sidebar() {
  const { user, signOut } = useAuth();
  return (
    <nav className="sidebar">
      <div className="brand">
        <div className="brand-mark">E</div>
        <div>
          <div className="brand-name">Electra</div>
          <span className="brand-sub">Command</span>
        </div>
      </div>
      {NAV.map((section) => (
        <div key={section.group}>
          <div className="nav-group">{section.group}</div>
          {section.links.map((link) => (
            <NavLink
              key={link.to}
              className="nav-link"
              to={link.to}
              {...(link.end ? { end: true } : {})}
            >
              <span className="nav-dot" />
              {link.label}
            </NavLink>
          ))}
        </div>
      ))}
      <div className="sidebar-foot">
        <div className="eyebrow">Operator</div>
        <div>{user?.email}</div>
        <button
          type="button"
          className="button-quiet"
          style={{ marginTop: 10, width: '100%' }}
          onClick={() => void signOut()}
        >
          Sign out
        </button>
      </div>
    </nav>
  );
}
